import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';

import { User } from '../models';
import { UserService } from './user.service';
import { take } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {
    
    currentUser: User;
    
  constructor(
    private router: Router,
    private userService: UserService,
  ) {

    this.userService.currentUser.subscribe(userData => {
    this.currentUser = userData;
    });
  }

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
     const routerLink = next['_routerState']['url'];
    
    this.userService.isAuthenticated.subscribe(
      (authenticated) => {
          
          
        if (authenticated) {
            
//            let acceso = false;
            let acceso = true;
            if ( !routerLink.includes("/fazil/") 
                || routerLink == "/fazil/perfil" ){//Lista de páginas de libre acceso
              acceso = true; //Son páginas no restringidas
            } else {
//              if (this.currentUser.tareas && this.currentUser.tareas.length > 0){
//                  acceso = this.puedeEjecutar(routerLink); //Acceso en función de los permisos del rol en la tarea
//              } 
            }

            if (!acceso) {
              this.router.navigate(['access']); //Ir a página de acceso restringido
              return false;
            }
            return this.userService.isAuthenticated.pipe(take(1));
        };
        
        this.router.navigate(['']); //Ir al inicio 
        return this.userService.isAuthenticated.pipe(take(1));
      }
    );
    
    return this.userService.isAuthenticated.pipe(take(1));
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
      return true;
  }
  
    ///////////////////////////////////////////////////////////////////////////
    //Control de acceso a acciones en pantalla
    // TODO: implementar estos métodos en todas las pantallas
    ///////////////////////////////////////////////////////////////////////////
    puedeEjecutar(routerLink:string):boolean{
        
        if (!this.currentUser.tareas || this.currentUser.tareas.length == 0){ //No tiene esta tarea
            return false;
        }
        
        const path = routerLink.replace("/fazil/", "");
        const tarea:any = this.currentUser.tareas.find(val => path.startsWith(val.routerLink));
        
        if (!tarea){ //No tiene esta tarea
            return false;
        }
        return tarea.puedeLeer || tarea.puedeEscribir || tarea.puedeBorrar || tarea.puedeImportarArchivo || tarea.puedeAsignarResponsable || tarea.puedeCargarIncidencia;
    }
}
